let fallbackCounter = 0;
const fallbackPageNonce = Math.random().toString(36).slice(2, 12) || '0';

function uuidV4FromBytes(bytes: Uint8Array) {
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

function fallbackIntentKey() {
  fallbackCounter += 1;
  const random = Math.random().toString(36).slice(2, 12) || '0';
  return `intent-${Date.now().toString(36)}-${fallbackPageNonce}-${fallbackCounter.toString(36)}-${random}`;
}

export function createIntentKey() {
  const webCrypto = globalThis.crypto;
  if (webCrypto) {
    if (typeof webCrypto.randomUUID === 'function') {
      try {
        const id = webCrypto.randomUUID();
        if (id) return id;
      } catch {
        // Some embedded browsers expose randomUUID but throw when it is invoked.
      }
    }
    if (typeof webCrypto.getRandomValues === 'function') {
      try {
        return uuidV4FromBytes(webCrypto.getRandomValues(new Uint8Array(16)));
      } catch {
        // Treat an unusable Web Crypto implementation as unavailable below.
      }
    }
  }
  return fallbackIntentKey();
}
